import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import AppWizard from "../../../shared/appWizard/appWizard";
import SuccessBox from "../../../shared/successBox/successBox";
import DatadogCreation from "./datadogCreation";

import { useDispatch, useSelector } from "react-redux";
import { createDatadogIntegration } from "../../../redux/actions/datadogIntegrationActions";
import {clouds} from "../../../utils/icons";

import "./datadogIntegration.scss";

const DatadogIntegration = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [wizardState, setWizardState] = useState({});
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const themeDark = useSelector(
    (state) => state.userPreferencesReducer.themeDark
  );

  const configWizard = [
    {
      step_title: "Setup",
      step_description: "Datadog integration details",
      content_title: "Datadog Integration",
      content: (
        <DatadogCreation
          wizardState={wizardState}
          setWizardState={setWizardState}
          setSubmitDisabled={setSubmitDisabled}
        />
      ),
      valid: true,
      beforeNextStep: async () => {
        setLoadingSubmit(true);

        const result = await dispatch(
          createDatadogIntegration(
            wizardState.name,
            wizardState.APIKey,
            wizardState.APPKey,
            wizardState.site,
          )
        );
        setLoadingSubmit(false);
        if (!result?.ok) {
          throw new Error(
            `Failed to create Datadog integration.`
          );
        }
      },
    },
    {
      step_title: "Completion",
      step_description: "",
      content_title: "Integration Created!",
      content: (
        <SuccessBox
          setSubmitDisabled={setSubmitDisabled}
          subTitle="The Resources from the Integration will take up to one hour to appear in the inventory"
          doesTakeTime={true}
        />
      ),
      valid: true,
    },
  ];

  return (
    <div className="DatadogIntegration">
      <AppWizard
        loadingSubmit={loadingSubmit}
        configWizard={configWizard}
        handleClose={() => history.goBack()}
        submitDisabled={submitDisabled}
        setSubmitDisabled={setSubmitDisabled}
        handleSubmit={() => history.push("/integrations")}
        iconSrc={clouds("datadog", themeDark)}
      />
    </div>
  );
};

export default DatadogIntegration;
